import FilterListIcon from '@mui/icons-material/FilterList';
import {Button, useTheme} from '@mui/material';

export default function CustomButton({
    text,
    variant,
    style,
    onClick,icon, disabled,color
    } : any) {
        
    const theme : any = useTheme()

    return (
        <Button onClick={onClick} style={style} variant={variant?variant:"outlined"} color={color?color:theme.button} disabled={disabled}><span style={{marginRight: '10px'}}>{icon}</span> <span>{text}</span></Button>
    )



}